import { Button } from "@mui/material";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { useComponent } from "../../hooks";
import { Loader, PageHeader } from "../../components";
import WorkflowDialog from "./list components/CreateWorkflowDialog";
import Table from "./list components/WorkflowList";

export default function WorkflowList({ pageID }) {
  const { activeBot } = useSelector((state) => state.memberDetails);
  const { axios, loader } = useComponent({ pageID });

  const [workflows, setWorkflows] = useState([]);
  const [dialogState, setDialogState] = useState(false);

  useEffect(() => {
    loader.start();
    axios({
      url: "/workflow/" + activeBot.ID,
    })
      .then((res) => {
        if (res.status) {
          setWorkflows(res.data);
          loader.apiComplete();
        }
      })
      .catch(() => {
        loader.apiComplete();
      });
  }, [axios, activeBot.ID, loader]);

  return (
    <Loader>
      <PageHeader
        pageName="Workflow"
        buttons={[
          <Button variant="contained" onClick={() => setDialogState(true)}>
            Add New Workflow
          </Button>,
        ]}
      />

      <Table workflows={workflows} />

      <WorkflowDialog
        dialogState={dialogState}
        setDialogState={setDialogState}
      />
    </Loader>
  );
}
